export default {
    id: 3,
    rank: 3,
    name: "Luckia",
    bonoEuros: 200,
    bonoCasino: 200,
    reviewUrl: "/default",
    bonoUrl: "https://www.luckia.es/promociones/detalle/-/ver/bienvenida-apuest-3/",
    bonoCasinoUrl: "https://www.luckia.es/promociones/detalle/-/ver/bienvenida-casino/",
    rating: 4.25,
    metaTitle: "Lucia: Opinión y Análisis 2020 | Obtén 15€ o 20€ Gratis",
    metaDescription: "Análisis y opinión franca de Luckia. La guía más completa para que todo apostante pueda sacar el máximo partido a su dinero y tiempo. ",
    imageUrl: "luckia.png",
    intoduction: `<p class="opinion-p-space">
    El Luckia Gaming Group fue fundado en 1972, e inicialmente se dedicó a la gestión de gramolas y maquinas
    tragamonedas recreativas para locales de hostelería, bingos, casinos y todo tipo de salones de apuesta presencial.<br />
    <br />
    Luckia.es, el ambicioso portal digital del grupo, se ha convertido en un referente español de juego online mediante
    su oferta de apuesta deportiva, casino online, casino en vivo y slots.<br />
    <br />
    Actualmente son los patrocinadores del Real Club Deportivo de La Coruña y tiene presencia en España, Chile, Perú,
    Colombia, Portugal, Croacia y Malta. Para el año 2021 se espera que operen en un total de 12 países.<br />
    <br />
    Se trata pues de una página de apuestas deportivas y de casino fiable. Correctamente registrada y con licencia de la
    Ordenación del Juego y un extenso catálogo de apuesta deportiva y juegos online que desarrollaremos a continuación.<br />
    <br />
    Si quieres leer una opinión detallada sobre Luckia, te invito a seguir conmigo.<br />
    <br />
    Si por el contrario ya has leído suficiente y te has animado a jugar en Luckia, pincha en el siguiente enlace y
    <a href="https://www.luckia.es/usuario/#/registro/" target="#blank"> obtén tus 200€ en apuestas deportivas gratuitas.</a>
</p>`,
    prosandCons: [
        {
            type: "pro",
            comment: "Cuotas altas"
        }, {
            type: "pro",
            comment: "Promociones semanales para usuarios registrados"
        }, {
            type: "pro",
            comment: "Mas de 500 tragamonedasm"
        }, {
            type: "con",
            comment: "Retiradas de dinero lentas"
        },
        {
            type: "con",
            comment: "Bono casino difícil de liberar"
        }
    ],
    deposit: ["paypal", "visa", "mastercard", "paysafe", "banktransfer", "skrill", "trustly"],
    withdraw: ["paypal", "visa", "mastercard", "neteller", "skrill", "trustly"],
    contact: {
        phoneNumber: "900 37 38 23",
        email: "clientes@luckia.es",
        chat: true
    },
    opinion: `<div id="main-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Variedad y Tipos de Apuestas
</div>
<div class="opinion-card-subtitle">
    Apuesta deportiva
</div>
<p class="opinion-p-space">
    El catálogo de Luckia incluye una amplia oferta de apuesta deportiva. Son más de 28 deportes distintos a los que
    puedes apostar, entre los que destacan:<br />
    <br />
    • Apuestas de futbol: como no puede ser de otro modo para una de las mejores casas de apuestas españolas, hay un
    espacio destacado y seguimiento exhaustivo de torneos nacionales: Copa del Rey, la Liga BBVA, Liga ASOBAL o la Liga
    ACB. Además, hay cobertura de las ligas más importantes del mundo como la Champions League, Premier League Inglesa,
    Europa League, Eurocopa y Mundial. No obstante, el catálogo futbolístico de Luckia también abarca ligas menos
    conocidas de todo el mundo como la Corea – K-League, La Premier League de Hong-kong, la Botola de Marruecos,
    etc.<br />
    • Apuestas de Tenis: encontramos mundiales de la ATP, WTA, dobles... y por obviamente la Copa Davis, Wimbledon y los
    Open de USA, Australia y Francia<br />
    • Apuestas de Ciclismo: Con el Paris Roubaix, la Vuelta a España, Tour de Francia, Tour de Flandes y más.<br />
    • Apuestas de Carreras de Caballos en los principales hipódromos de Inglaterra e Irlanda<br />
    • Las mejores peleas de boxeo y MMA del año<br />
    <br />
    Desde los deportes más populares a otros menos famosos como las carreras de galgos, el balonmano, el hockey sobre
    hielo, los dardos, el futbol americano y más.<br />
    <br />
    La cobertura de e-Sports también es bastante buena. Se da seguimiento a competiciones de Counter Strike, League of
    Legends (LOL), Overwatch, Dota, Arena of Valor y Rainbow Six.<br />
    <br />
    Podremos realizar apuestas prepartido y apuestas en vivo para ciertas ligas, las cuales se realizan mientras se
    desarrolla evento. Para realizar apuestas en vivo es muy importante conocer los datos estadísticos de los equipos y
    saber anticiparse a los acontecimientos del evento.<br />
    <br />
    Para las <strong>apuestas en directo</strong>, Luckia pone a disposición de sus clientes <strong>estadísticas a
        tiempo real</strong> y un panel
    interactivo bastante bueno que se puede encontrar del lado derecho en la sección de apuestas en vivo. Allí nos
    podremos informar a tiempo real sobre datos del partido, por ejemplo, en caso de que el partido fuese de futbol
    tendríamos datos de posesión de pelota, ratio de ataques peligrosos por equipo, tiros a portería, tiros fuera,
    tarjetas amarillas y rojas, faltas, paradas y todo tipo de información de apoyo para asistirnos con nuestras
    apuestas en directo. La clave es anticiparse.<br />
    <br />

<div class="opiniones-img">
    <img src="assets/images/lu_descanso.png" />
</div>

<strong>#PROTip:</strong> Para las apuestas en vivo, Luckia ofrece la función <strong>cash out</strong> con la que
puedes elegir cerrar
tu apuesta en cualquier momento del partido e irte con las ganancias conseguidas hasta ese instante.<br />
<br />
<strong>Las cuotas</strong> son generalmente altas y cambian constantemente en función de lo sucedido durante el evento.
Las apuestas Luckia se resuelven a los pocos minutos de estar disponibles los datos públicos sobre el resultado del
objeto de la apuesta. Una vez resuelta la apuesta, si resulta ganadora inmediatamente se recibe el importe
correspondiente en el monedero de la cuenta del usuario.<br />
<br />
</p>

<div class="opinion-card-subtitle">
    Casino
</div>
<p class="opinion-p-space">
    Luckia posee uno de los catálogos de slots y casino online más completos de España. Y es que Luckia compone su
    catálogo a base de trabajar con varios de los más grandes proveedores de slots y juegos como son MGA, NetEnt,
    Betdigital, Big Time Gaming, Micrograming, Thunderkick y más.<br />
    <br />
    Para Luckia el casino online supone su más amplia y ambiciosa oferta de entretenimiento virtual. La oferta casino va
    desde las clásicas tragamonedas, ruleta online y por supuesto, casino en vivo.<br />
    <br />
    Luckia casino cuenta con <strong>más de 500 tragaperras online</strong>. Si si, has leído bien, 500 tragaperras
    online que se puedes
    jugar desde tu móvil, ordenador o Tablet. Uno de los mejores catálogos de slots en España.<br />
    <br />
    Las tragamonedas de Luckia tiene una versión demo o versión gratuita en la que podrás probar como funciona sin
    arriesgar tus fondos.<br />
    <br />
    En el extenso repertorio de slots nos encontraremos con los títulos preferidos de los jugadores de Luckia como “Mad
    Mad Monkey”, “Starburst”, “Bonanza Megaways” o “La Mina de Oro” en la cual debes excavar para conseguir
    tesoros.<br />
    <br />
    También tenemos la <strong>“The Incredible Balloon Machine”</strong>, una de mis preferidas.<br />
    <br />
    Se trata de un globo que explota de manera aleatoria y tu tienes que intentar recolectar tus ganancias antes de que
    el globo explote. Lo primero es realizar la apuesta, seguidamente tanto el globo como tus beneficios empezarán a
    hincharse, cuanto más tardes en pinchar el botón de “Collect” más crecerá el bote, pero si el globo explota antes de
    que pinches perderás la apuesta. Lo interesante, es que el rango de incremento del crédito es de hasta 7303%, es
    decir con una apuesta de 2€ podrías llevarte hasta 146€, además aparecen multiplicadores de premio aleatorios de
    hasta x10, con lo cual por una apuesta de 2€ podrías acabar llevándote casi 1.500€.<br />
    <br />
    No faltan opciones si prefieres los juegos clásicos de casino.<br />
    <br />
    Luckia ofrece <strong>más de 10 mesas de ruleta virtual y 4 en vivo</strong>. Además de juegos de naipes míticos
    como el Blackjack
    clásico o americano y el Baccarat.<br />
    <br />
    La retransmisión de la ruleta en directo está disponible 24/7 y es de gran calidad. La imagen, los sonidos y un
    croupier real que comenta las jugadas dan la sensación de estar en un casino de verdad.<br />
    <br />
<div class="opiniones-img">
    <img src="assets/images/lu_ruleta.png" />
</div>
También tendremos a nuestra disposición más de 30 <strong>juegos de bingo</strong> online.
</p>
<!-- ----------------------------------------------------------------------------------------------------------------------------------->
<div id="bonos-prom-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Bonos y Promociones
</div>
<div class="opinion-card-subtitle">
    Bono para Apuesta Deportiva: 200€ en Freebets
</div>

<div class="opiniones-img">
    <img src="assets/images/lu_hasta200Banner.jpg" />
</div>

<p class="opinion-p-space">
    Si eres nuevo usuario puedes <a href="https://www.luckia.es/usuario/#/registro/" target="#blank">registrarte</a> y
    conseguir hasta 200€ extra en apuestas gratis. Ahora bien, ¿qué hay que
    hacer para conseguir el bono?<br />
    <br />
    Lo primero es regístrate correctamente y seleccionar el bono de bienvenida que encontraras en tu perfil de usuario.
    La cantidad máxima para beneficiarte de este bono es de 200€ y se desbloquea en los siguientes pasos:<br />
    <br />
    1. Realiza tu primera apuesta simple o combinada de mínimo 5€ y máximo de 100€ con una cuota de al menos 2.00.
    Luckia te devolverá el 50% de dicha apuesta en modo de “Freebet” y estará disponible en tu cuenta de usuario durante
    7 días. Es decir, si tu primera apuesta fue de 200€, recibirás una apuesta gratuita de 100€. Y si tu primera apuesta
    fuese de 100€ recibirías una apuesta gratuita de 50€.<br />
    <br />
    2. Para conseguir los 100€ restantes del bono tienes 30 días. Y deberás hacer al menos 10 apuestas a una cuota de 2
    por un valor total de 200€ mínimo. Las apuestas pueden ser de cualquier monto, lo impórtate es hagas un mínimo de 10
    apuestas a cuota 2 y que en total alcances la cifra de 200€ apostados. La recompensa de esta segunda parte será 100€
    repartidos en 10 apuestas gratuitas de 10€ cada una<br />
    <br />
    Las apuestas pueden ser simples o combinadas, siempre y cuando la cuota final sea superior a 2.<br />
    <br />
    Conseguir un bono de bienvenida para apuestas deportivas es la mejor forma de empezar ganando cuando te registras en
    una casa de apuestas deportivas.<br />
    <br />
</p>

<div class="opinion-card-subtitle">
    Bono para casino online: 200% de tu primer deposito hasta 200€.
</div>

<div class="opiniones-img">
    <img src="assets/images/lu_casino200Banner.jpg" />
</div>

<p class="opinion-p-space">
    El bono de 200€ para casino es el bono de bienvenida y obsequio que Luckia ofrece a sus clientes por su registro en
    la plataforma la primera vez que van a jugar al casino. Se trata de un bono extremadamente llamativo a primera
    vista. Veremos a continuación que debemos hacer para desbloquearlo.<br />
    <br />
    Para acceder al bono de bienvenida hay que realizar un registro valido y luego ir a tu perfil de usuario, ahí
    encontraras el bono casino de 200% extra del primer deposito hasta un máximo de 200€. Si ingresas 10€, dispondrás de
    30€, y si ingresas 200€ dispondrás de 600€.<br />
    <br />
    No necesitas un código, simplemente <a href="https://www.luckia.es/usuario/#/registro/" target="#blank">registrarte
        en este enlace</a> y hacer un ingreso de al menos 10€, el bono se
    activará automáticamente.<br />
    <br />
    El bono se consigue de manera directa y no en forma de apuestas gratuitas. Básicamente, tu monedero Luckia se divide
    en dos, una parte con saldo real y otra con saldo del bono que se puede retirar tras liberarlo. Tras la liberación
    del bono, el saldo del monedero de bono pasará al monedero con dinero real.<br />
    <br />
    Ahora bien, la condición de liberación del bono la encuentro excesiva y te explico por qué.<br />
    <br />
    Tienes los 60 días posteriores a la activación del bono para jugar una cantidad igual o superior a 60 veces el
    importe del bono. Es decir, si tu primer ingreso ha sido de 20€, se te habrá abonado a tu monedero 40€
    correspondientes al bono para un total de 60€. Pues bien, en los siguientes 60 días, deberás jugar 2.400€ para
    desbloquear el bono de 40€.<br />
    <br />
    A mi manera de ver, el bono Luckia Casino es mas un premio de lealtad que un incentivo para nuevos jugadores.<br />
    <br />
    Otras promociones<br />
    <br />
    Luckia es un excelente casino online, y si el bono de bienvenida no te ha gustado aun merece la pena <a
        href="https://www.luckia.es/usuario/#/registro/" target="#blank">regístrate</a> para
    aprovechar otro tipo de promociones. Algunas de ellas pueden ser:<br />
    <br />
    1. Bono de 10€ diario jugando a 20€ en la Slot de Tarzan.<br />
    2. 50 sorteos aleatorios de 10€ cada uno.<br />
    3. Bono puntual de 20€ automático al jugar 10€ en la ruleta en vivo<br />
    4. Hasta 60% extra de premio para apuestas combinadas.<br />
    <br />
    <strong>#PROTip:</strong> no olvides revisar frecuentemente la sección de promociones Luckia, cada semana las
    cambian.
</p>

<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="depositos-retiros-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Cuotas
</div>
<p class="opinion-p-space">
    Como es de esperar, todas las apuestas tienen una cuota asociada. Una cifra por la que nosotros apostamos y la que
    conseguiremos en el caso de acertar nuestro pronóstico.<br />
    <br />
    Las cuotas las marcan las bookies, pero tal y como apuntábamos al inicio, <strong>en Luckia las cuotas son un punto
        a favor.</strong>
    Aunque muchas veces la diferencia sea de unos pocos céntimos, rara vez encontramos a Luckia entre las más flojas, y
    cuando lo hace es en mercados de poca proyección.<br />
    <br />
    Al igual que en la mayoría de las casas de apuestas, las cuotas más atractivas están reservadas para los deportes
    mas populares como el futbol, el tenis o el baloncesto. Sin embargo, Luckia sobresale al presentar cuotas
    especialmente generosas para algunas apuestas puntuales como las de ganador de una liga, goleadores de un partido,
    etc.<br />
    <br />
    Para apostar en Luckia basta con hacer click en el partido de tu preferencia para abrir la hoja de apuesta. Allí
    debes especificar si quieres realizar una apuesta simple, combinada o de sistema. En esta misma ventana podrás ver
    las cuotas y cuáles serán las ganancias en caso de acertar el pronóstico.<br />
    <br />
    Merece la pena saber que las cuotas serán siempre más altas para las apuestas combinadas que para las simples. ¡Por
    lo que si tienes entre manos una buena apuesta combinada no la dejes escapar!<br />
    <br />
    En cualquier caso, queremos animarte a entrar en Luckia y a conseguir cuotas competitivas en tus apuestas deportivas
    para disfrutar de los partidos con aun más emoción.
</p>

<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="depositos-retiros-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Depósitos, Retiros y Métodos de Pago
</div>
<p class="opinion-p-space">
    Luckia acepta un número limitado de plataformas para que realices tus depósitos y retiradas de fondos.
</p>
<div class="opinion-card-subtitle">
    Depósitos
</div>
<p class="opinion-p-space">
    Solo está permitido realizar depósitos desde medio de pago españoles. En caso de monederos online como PayPal o
    Skrill, solo se admitirán cuentas españolas. <br />
    <br />
<div class="info-grid-4">
    <div class="info-grid-4-header">Método de pago </div>
    <div class="info-grid-4-header">Ingreso Mínimo</div>
    <div class="info-grid-4-header">Comisión</div>
    <div class="info-grid-4-header">Tiempo de proceso</div>
    <div>Visa</div>
    <div>1€</div>
    <div>Ninguna</div>
    <div>Inmediato</div>
    <div>Mastercard</div>
    <div>1€</div>
    <div>Ninguna</div>
    <div>Inmediato</div>
    <div>PayPal</div>
    <div>10€</div>
    <div>Ninguna</div>
    <div>Inmediato</div>
    <div>Skrill</div>
    <div>20€</div>
    <div>Ninguna</div>
    <div>Inmediato</div>
    <div>Trustly</div>
    <div>20€</div>
    <div>Ninguna</div>
    <div>Inmediato</div>
    <div>Paysafecard</div>
    <div>5€</div>
    <div>Ninguna</div>
    <div>Inmediato</div>
    <div>Transferencia bancaria</div>
    <div>10€</div>
    <div>Ninguna</div>
    <div>1-3 días hábiles</div>
</div>
<br />
<br />
De acuerdo a la normativa española de juego, existen límites de ingresos máximos de forma automática: un límite
diario de 600€, limite semanal de 1.500€ y un limite mensual de 3000€. Dichos limites se pueden reducir en tu perfil
de jugador, pero en caso de querer aumentarlos, deberás hacer una petición al soporte técnico de Luckia. Este hecho
es similar en cualquier casa de apuesta correctamente regulada para operar en España
</p>
<div class="opinion-card-subtitle">
    Retiros
</div>
<p class="opinion-p-space">
    Para cobrar un reintegro debes clicar en tu perfil de jugador en la esquina superior derecha y seleccionar la opción
    ‘Retirar’.<br />
    <br />
    Para retirar el dinero podrás utilizar las mismas formas de pago, excepto paysafecard. <br />
    <br />
<div class="info-grid-4">
    <div class="info-grid-4-header">Método de pago </div>
    <div class="info-grid-4-header">Retiro Mínimo</div>
    <div class="info-grid-4-header">Comisión</div>
    <div class="info-grid-4-header">Tiempo de proceso</div>
    <div>Visa</div>
    <div>10€</div>
    <div>Ninguna</div>
    <div>2-3 días hábiles</div>
    <div>Mastercard</div>
    <div>10€</div>
    <div>Ninguna</div>
    <div>2-3 días hábiles</div>
    <div>PayPal</div>
    <div>10€</div>
    <div>Ninguna</div>
    <div>24 horas máximo</div>
    <div>Skrill</div>
    <div>10€</div>
    <div>Ninguna</div>
    <div>24 horas máximo</div>
    <div>Trustly</div>
    <div>20€</div>
    <div>Ninguna</div>
    <div>24 horas máximo</div>
    <div>Neteller</div>
    <div>20€</div>
    <div>Ninguna</div>
    <div>2-3 días hábiles</div>
</div>
<br />
<br />
</p>
<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="seguridad-fiabilidad-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Seguridad y Fiabilidad
</div>
<p class="opinion-p-space">
    Luckia es una casa de apuestas legitima. Correctamente registrada y con licencia de la DGOJ para operar en España.
    Por lo que, cumple con todos los estándares de seguridad de protección y encriptado de datos.<br />
    <br />
    Detrás de Luckia se encuentra el Luckia Gaming Group, empresa con mas de 50 años de trayectoria en el sector
    apuestas tanto físicas como online.<br />
    <br />
    Recordemos además que son los patrocinadores del Real Club Deportivo de La Coruña, lo que le da cierto punto de
    prestigio.<br />
    <br />
    Como en cualquier otra casa de apuestas, pueden existir quejas pero el servicio de atención al cliente es sólido y
    eficaz, siempre podrás comunicarte con ellos directamente para resolver cualquier incidente.
</p>
<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="ui-ux-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Interfaz y Experiencia de Usuario
</div>
<p class="opinion-p-space">
    La interfaz de luckia.es es fácil de navegar y de entender desde el primer momento. No defraudara a quienes busquen
    una web de apuesta segura y funcional.<br />
    <br />
    De entrada, te será muy fácil identificar a donde ir. En el menú de navegación principal que se encuentra arriba y
    centrado, encontraras los grandes grupos de apuestas: Apuesta deportiva, apuesta en vivo, fantasy, casino, slots,
    apuesta deportiva virtual y una guía de locales físicos.<br />
    <br />
    Para la sección de apuesta deportiva, encontrarás todos los deportes del lado izquierdo con un resumen de las
    partidas disputadas de cada deporte en el centro de la pantalla. Además, ofrecen cuotas en tres formatos. Cuotas
    americanas, decimales y fraccionales. Las encontraras a la derecha debajo de tu perfil de jugador.<br />
    <br />
    La sección casino se divide en ruleta en vivo, blackjack y ruleta normal.<br />
    <br />
    La sección de slots se divide en bingo, incredible balloon, rasca y gana y un campo de búsqueda en donde puede
    encontrar tu tragamonedas por nombre.
</p>
<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="atencion-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Atención al cliente
</div>
<p class="opinion-p-space">
    El equipo de atención está disponible cada día de 9:00 a 00:00 h. Y le puedes contactar de las siguientes
    maneras:<br />
    <br />
    • Teléfono gratuito: 900 37 38 23<br />
    • Correo electrónico a clientes@luckia.es<br />
    • Chat en vivo de 9:00 a 00:00 h. En caso de contactar por el chat fuera del horario de atención al cliente,
    podremos dejar un mensaje y nos contestaran lo antes posible. <br />
    <br />
</p>
<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="adicionales-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Características Adicionales
</div>
<div class="opinion-card-subtitle">
    Porras
</div>
<p class="opinion-p-space">
    Las porras son un elemento diferenciador que son todo un acierto.<br />
    <br />
    <strong>#PROTip:</strong> En Luckia, lo más destacado son las porras por un resultado concreto, con un bote de premio interesante y
    un depósito mínimo de 1€.
</p>
<div class="opinion-card-subtitle">
    Luckia Fantasy
</div>
<p class="opinion-p-space">
    Si te gusta el futbol, es posible que te quedes un buen rato jugando al Luckia Fantasy.<br />
    <br />
    Crea tu equipo virtual y participa en algún torneo existentes o crea uno nuevo. El equipo virtual esta conformado
    por jugadores reales y hay distintas maneras de hacer puntos, como cuando un jugador en tu equipo da una asistencia,
    marca, juega 60 minutos, marca de penalti, etc.
</p>
<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="conclusion-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Conclusión
</div>
<p class="opinion-p-space">
    En Luckia la variedad supera la ofrecida en muchas otras páginas de apuestas con mayor tradición y poder económico.<br />
    <br />
    En mi opinión, Luckia apuesta a la calidad y a la fidelización de sus jugadores. Y no a gastar grandísimas sumas de
    dinero en publicidad para atraer a masas de nuevos jugadores.<br />
    <br />
    He quedado gratamente sorprendida con la cantidad de juegos disponibles en Luckia Casino y con la calidad de los
    mismos. El software del casino está muy bien diseñado y cuentan con gráficos de altísima calidad. Aunque echo de
    menos una buena sala de Poker en directo.<br />
    <br />
    Si bien el bono para casino me parece escaso. Las promociones recurrentes para usuarios ya registrados me han
    encantado. Y también el bono de bienvenida para apuesta deportiva.<br />
    <br />
    De momento no son una casa de apuesta deportiva de elite internacional, pero si estás buscando por una opción
    emergente, dinámica y con una extensa cobertura para deportes nacionales y e internacional, Luckia no te
    decepcionara. Recomiendo que le eches un vistazo.
</p>`
}